import React, { useEffect } from "react";
import {
  DefaultLoadingOverlayProps,
  ILoadingOverlayProps,
} from "./LoadingOverlay.types";
import LoadingStyles from "./LoadingOverlay.styles";
import STREETLIGHT_ICON from "../icon/streetlight-icon/StreetlightIcon.component";
import { EBracketTypes } from "../../shared/enums/utility.enums";
import { startLoadingAnimation } from "./LoadingOverlay.animations";

const LOADING_OVERLAY: React.FC<ILoadingOverlayProps> = () => {
  useEffect(() => {
    startLoadingAnimation();
  }, []);

  return (
    <LoadingStyles.LoadingOverlayContainer
      className="loading-overlay"
      data-testid="loading-overlay"
    >
      <LoadingStyles.LoadingIconContainer className="loading-icon-container">
        <div className="svg-container">
          <STREETLIGHT_ICON
            className="cobra-loading"
            type={EBracketTypes.COBRA}
            reported={0}
            fill="#0079c1"
            bgFill="#ffffff"
          />
          <STREETLIGHT_ICON
            className="hanging-loading"
            type={EBracketTypes.CENTER_SUSPENSION}
            reported={0}
            fill="#0079c1"
            bgFill="#ffffff"
          />
          <STREETLIGHT_ICON
            className="decorative-loading"
            type={EBracketTypes.POST_TOP}
            reported={0}
            fill="#0079c1"
            bgFill="#ffffff"
          />
        </div>

        <div className="loading-message-container">
          <h1 className="loading-message">Streetlights Loading...</h1>
          <h1 className="loading-sub-message">One Moment Please...</h1>
        </div>
      </LoadingStyles.LoadingIconContainer>
    </LoadingStyles.LoadingOverlayContainer>
  );
};

LOADING_OVERLAY.defaultProps = DefaultLoadingOverlayProps;
export default LOADING_OVERLAY;
